import styled from 'styled-components';

interface IContentProps {
  isSend: boolean;
}
export const Container = styled.div`
  .containerMessagesUnreads {
    display: flex;
    justify-content: center;
    background: ${({ theme }) => theme.colors.gray};
    opacity: 1;
    border-radius: 0.5rem;
    .messagesUnreads {
      display: flex;
      color: ${({ theme }) => theme.colors.background_white};
    }
  }
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 15rem;
  max-height: 15rem;
  overflow-y: auto;
`;

export const Content = styled.div<IContentProps>`
  display: flex;
  justify-content: ${({ isSend }) => (isSend ? 'flex-end' : 'flex-start')};
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem;
  .contentConversationMessage {
    display: flex;
    flex-direction: column;
    .containerMessage {
      display: flex;
      padding: 0.5rem 1rem 0.5rem 0.5rem;
      background-color: ${({ theme, isSend }) =>
        isSend ? theme.colors.primary : theme.colors.tertiary_500};
      border-radius: 0.5rem;
      position: relative;
      .message {
        max-width: 12rem;
        display: flex;
        color: ${({ theme }) => theme.colors.background_white};
        justify-content: left;
        font-size: 1.1rem;
        padding: 0.2rem;
      }
      .read {
        position: absolute;
        bottom: 0.2rem;
        right: 0.2rem;
        width: 1rem;
        height: 1rem;
        fill: ${({ theme }) => theme.colors.blue_200};
      }
      .send {
        position: absolute;
        bottom: 0.2rem;
        right: 0.2rem;
        width: 1rem;
        height: 0.9rem;
        fill: ${({ theme }) => theme.colors.blue_200};
      }
    }
    p {
      display: flex;
      font-size: 0.7rem;
      color: ${({ theme }) => theme.colors.gray};
    }
  }
`;
